export const GET_FINANCING_PER_VALUE_SIMULATIONS = '/financing/all-requisitions'
export const GET_FINANCING_PER_QUOTATION_SIMULATIONS =
  '/financing/all-quotation'
export const GET_FINANCING_INSURANCE_PERCENTAGE = '/financing/insurance-fee'
